import { Component, Input, OnInit } from '@angular/core';
import { FunctionalCapabilitiesNoteSection } from 'src/app/model/shared/functional-capabilities-note-section';

@Component({
  selector: 'app-functional-capabilities-note-section',
  templateUrl: './functional-capabilities-note-section.component.html',
  styleUrls: ['./functional-capabilities-note-section.component.scss']
})
export class FunctionalCapabilitiesNoteSectionComponent implements OnInit {
  @Input() noteSections: FunctionalCapabilitiesNoteSection[] = [];
  @Input() isDefault: boolean = true;
  constructor() {}

  ngOnInit(): void {}
}
